import {Controller} from "./helpers/controller";

export class PasswordDisplayControl extends Controller {

    constructor(element: HTMLElement) {
        super(element);

        $(element).on('click', (e)=>{
            let newTarget = $(e.currentTarget).prev();
            if (newTarget.attr('type') == "password") {
                newTarget.attr( "type", "text" );
            } else {
                newTarget.attr( "type", "password" );
            }
        });
    }
  
}